import React from 'react';
import { Heart, AlertTriangle } from 'lucide-react';

// Список медицинских условий, влияющих на метаболизм и питание
const medicalConditionsList = [
  { id: 'diabetes', name: 'Сахарный диабет', impact: 'Требуется контроль уровня углеводов и гликемического индекса продуктов.' },
  { id: 'hypothyroidism', name: 'Гипотиреоз', impact: 'Замедленный метаболизм, может потребоваться дополнительная корректировка калорий.' },
  { id: 'hypertension', name: 'Гипертония', impact: 'Рекомендуется ограничение соли и мониторинг потребления калия.' },
  { id: 'celiac', name: 'Целиакия', impact: 'Необходима безглютеновая диета.' },
  { id: 'ibs', name: 'Синдром раздраженного кишечника', impact: 'Индивидуальные ограничения в зависимости от триггеров.' },
  { id: 'lactose', name: 'Непереносимость лактозы', impact: 'Необходимо исключение или ограничение молочных продуктов.' },
  { id: 'gout', name: 'Подагра', impact: 'Ограничение продуктов с высоким содержанием пуринов.' },
  { id: 'pcos', name: 'Синдром поликистозных яичников', impact: 'Может потребоваться снижение углеводов и контроль инсулина.' },
  { id: 'fatty_liver', name: 'Жировой гепатоз', impact: 'Рекомендуется ограничение алкоголя и простых углеводов.' },
  { id: 'gastritis', name: 'Гастрит/Язва', impact: 'Ограничение острой, кислой пищи и равномерное распределение приемов пищи.' }
];

const MedicalConditionsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Обработчик изменения медицинских условий
  const handleMedicalConditionChange = (e) => {
    const { checked, value } = e.target;
    
    setFormData(prev => {
      let updatedConditions = [...prev.medicalConditions];
      
      if (checked) {
        // Добавляем условие, если его еще нет
        if (!updatedConditions.includes(value)) {
          updatedConditions.push(value);
        }
      } else {
        // Удаляем условие
        updatedConditions = updatedConditions.filter(condition => condition !== value);
      }
      
      return {
        ...prev,
        medicalConditions: updatedConditions
      };
    });
  };

  // Функция для установки formData - создаем ее здесь, так как нам не передали setFormData напрямую
  const setFormData = (updater) => {
    if (typeof updater === 'function') {
      const newFormData = updater(formData);
      
      // Создаем событие для имитации изменения
      const event = {
        target: {
          name: 'medicalConditions',
          value: newFormData.medicalConditions
        }
      };
      
      // Вызываем переданный handleInputChange
      handleInputChange(event);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="considerMedicalConditions"
            checked={formData.considerMedicalConditions}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать медицинские особенности при расчете
          </span>
        </label>
      </div>

      {formData.considerMedicalConditions && (
        <>
          <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-lg">
            <div className="flex items-start">
              <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-1" />
              <div>
                <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
                  Важная информация
                </h4>
                <p className="text-xs text-yellow-600 dark:text-yellow-400">
                  Этот калькулятор предоставляет лишь общие рекомендации. Если у вас есть хронические заболевания 
                  или особые медицинские состояния, обязательно проконсультируйтесь с врачом или диетологом 
                  перед изменением рациона питания.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-3">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
              <Heart className="w-4 h-4 mr-2 text-red-500" />
              Отметьте медицинские состояния, которые у вас есть:
            </label>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
              {medicalConditionsList.map((condition) => (
                <div key={condition.id} className="flex items-start">
                  <input
                    type="checkbox"
                    id={`condition-${condition.id}`}
                    value={condition.id}
                    checked={formData.medicalConditions.includes(condition.id)}
                    onChange={handleMedicalConditionChange}
                    className="form-checkbox mt-1"
                  />
                  <label htmlFor={`condition-${condition.id}`} className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                    <span className="font-medium">{condition.name}</span>
                    <span className="block text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                      {condition.impact}
                    </span>
                  </label>
                </div>
              ))}
            </div>
            
            {errors.medicalConditions && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.medicalConditions}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MedicalConditionsSection;